"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendAnalyticEvent = void 0;
var react_ga_1 = require("react-ga");
var episodEnabled = process.env.REACT_APP_MARKET_VALUES.IS_EPISOD_ENABLED === 'true';
var sendAnalyticEvent = function (_a, provider) {
    var label = _a.label, action = _a.action, category = _a.category, pagePath = _a.pagePath;
    if (provider === void 0) { provider = 'reactga'; }
    var isEpisode = provider === 'episod' || episodEnabled;
    if (isEpisode) {
        if (category === 'pageview') {
            window.sendEvent({
                event_category: 'pageview',
                page_path: pagePath,
            });
        }
        else {
            window.sendEvent({
                event_label: label,
                event_action: action,
                event_category: category,
            });
        }
    }
    else if (category === 'pageview') {
        react_ga_1.default.pageview(pagePath);
    }
    else {
        react_ga_1.default.event({ action: action, category: category, label: label });
    }
};
exports.sendAnalyticEvent = sendAnalyticEvent;
exports.default = {};
